import React from "react";
import AccountPayments from "./accountPayments";
import Enroll from "./easyPaySettingPayments/enroll";
import { Outlet, useLocation } from "react-router";

const MyAccountPayments = (prop) => {
  const location = useLocation();
  const salesAgreementNumbers = location.state || {};
  return (
    <>
      {location.pathname == "/my-account/payments" ? (
        <AccountPayments />
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default MyAccountPayments;
